import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = [];

export default handleActions(
  {
    [Actions.LOAD_UNIVERSITIES_DONE]: (_, { payload: universities }) =>
      universities,
  },
  initialState,
);
